const config = {
  localUrl: 'https://gcxy.alumni-resource.com/',
};

/**
 * Get app config
 *
 * @param {'localUrl'} key
 * @returns
 */
export default function getAppConfig(key) {
  return config[key];
}



// WEBPACK FOOTER //
// ./src/utils/getAppConfig.js